"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  DeviceAttestation: () => DeviceAttestation
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native = require("react-native");
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_unavailable = require("./unavailable");
var hybrid;
function native() {
  if (import_react_native.Platform.OS !== "ios") throw new Error("DeviceAttestation requires an iOS native build");
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneDeviceAttestation");
  return hybrid;
}
function getAvailability() {
  try {
    return native().getAvailability();
  } catch (error) {
    return (0, import_nativeError.rethrowNativeError)(error);
  }
}
function generateKey() {
  return native().generateKey().catch(import_nativeError.rethrowNativeError);
}
function attestKey(keyId, clientDataHashBase64) {
  return native().attestKey(keyId, clientDataHashBase64).catch(import_nativeError.rethrowNativeError);
}
function generateAssertion(keyId, clientDataHashBase64) {
  return native().generateAssertion(keyId, clientDataHashBase64).catch(import_nativeError.rethrowNativeError);
}
function generateDeviceToken() {
  return native().generateDeviceToken().catch(import_nativeError.rethrowNativeError);
}
var nativeDeviceAttestation = Object.freeze({
  getAvailability,
  generateKey,
  attestKey,
  generateAssertion,
  generateDeviceToken
});
var DeviceAttestation = import_react_native.Platform.OS === "android" ? import_unavailable.DeviceAttestation : nativeDeviceAttestation;
//# sourceMappingURL=index.native.js.map
